export default {
  loading: false,
  ordersToChangeStatus: [],
  ordersSelected: [],
  form: {
    file: null,
  },
  formMicro: {
    macro_status: null,
    id: null,
    code: null,
    message: '',
    date: new Date(),
    time: new Date(),
  },
  formAction: {
    changeBy: null,
    status: null,
    date: new Date(),
    time: new Date(),
  },
  filters: {},
  shipperEvents: [],
  files: [],
  filesCount: null,
  currentPage: 1,
  perPage: 10,
  logs: [],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/change-order/store/states.js